export interface IComments {
  createdAt: string;
  id: number;
  status: number;
  text: string;
  totalReplies?: number;
  replies?: IComments[];
  user: {
    avatar: string;
    id: number;
    name: string;
  };
}

interface ICommentData {
  id: number;
  parent?: string;
  created_at: string;
  text: string;
  status: number;
  total_replies: number;
  course: {
    id?: number;
    title?: string;
  };
  module: {
    id?: number;
    title?: string;
  };
  lesson: {
    id?: number;
    title?: string;
  };
  user: {
    name: string;
    avatar?: string;
  };
}
export interface IComment {
  page: number;
  pageSize: number;
  data: ICommentData[];
  isFetching: boolean;
  totalPages: number;
}

export enum enCommentStatus {
  'waiting-aproval' = 0,
  'public' = 1,
  'private' = 2,
}
